import { NgModule } from '@angular/core';

import { TitleComponent } from './title.component';

@NgModule({
  declarations: [
    TitleComponent
  ],
  exports: [
    TitleComponent
  ]
})
export class TitleModule { }
